import React, { useState } from "react";
import ShopSection from "../components/ui/ShopSection";
import Helmet from "../components/helmet/Helmet";
import { Container, Row, Col } from "reactstrap";
import products from "../assets/data/products";
import ProductsList from "../components/ui/ProductsList";
import "../style/shop.css";

const Shop = () => {
	const [productsData, setProductsData] = useState(products);

	const handleFillter = (e) => {
		const filterValue = e.target.value;
		if (filterValue === "sofa") {
			const filteredProducts = products.filter(
				(item) => item.category === "sofa",
			);
			setProductsData(filteredProducts);
		}
		// end sofa

		if (filterValue === "mobile") {
			const filteredProducts = products.filter(
				(item) => item.category === "mobile",
			);
			setProductsData(filteredProducts);
		}

		// end mobile

		if (filterValue === "chair") {
			const filteredProducts = products.filter(
				(item) => item.category === "chair",
			);

			setProductsData(filteredProducts);
		}
		// end chair

		if (filterValue === "watch") {
			const filteredProducts = products.filter(
				(item) => item.category === "watch",
			);
			setProductsData(filteredProducts);
		}
		// end watch

		if (filterValue === "wireless") {
			const filteredProducts = products.filter(
				(item) => item.category === "wireless",
			);
			setProductsData(filteredProducts);
		}
		//  end wireless
		if (filterValue === "cosmetics") {
			const filteredProducts = products.filter(
				(item) => item.category === "Cosmetics",
			);
			setProductsData(filteredProducts);
		}
	};
	// Cosmetics;

	const handleSearch = e => {
		const searchTerm = e.target.value

		const searchProducts = products.filter(item => item.productName.toLowerCase().includes(searchTerm.toLowerCase()))

		setProductsData(searchProducts)
	}
	return (
		<Helmet title="shop">
			<ShopSection title="Products" />

			<section>
				<Container>
					<Row>
						<Col lg="3" md="6">
							<div className="filter__widget mt-2">
								<select onChange={handleFillter}>
									<option>Filter By Category</option>
									<option value="sofa">Sofa</option>
									<option value="mobile">Mobile</option>
									<option value="chair">Chair</option>
									<option value="watch">Watch</option>
									<option value="wireless">Wireless</option>
								</select>
							</div>
						</Col>
						<Col lg="3" md="6">
							<div className="filter__widget mt-2">
								<select>
									<option>Sort By </option>
									<option value="ascending">Ascending</option>
									<option value="descending">Descending</option>
								</select>
							</div>
						</Col>
						<Col lg="6" md="6">
							<div className="search__box mt-2">
								<input type="text" placeholder="Search" onChange={handleSearch}/>
								<span>
									<i className="ri-search-line"></i>
								</span>
							</div>
						</Col>
					</Row>
				</Container>
			</section>
			{/* View */}
			<section>
				<Container>
					<Row>
						{productsData.length === 0 ? (
							<h1 className="text-center fs-4">No products are Found!</h1>
						) : (
							<ProductsList data={productsData} />
						)}
					</Row>
				</Container>
			</section>
		</Helmet>
	);
};

export default Shop;
